import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyMembers: [],
  companyMemberLoading: false,
};

const companyMemberSlice = createSlice({
  name: "companyMemberSlice", // slice name
  initialState, // initial state
  reducers: {
    // reducers
    setCompanyMembers(state, action: PayloadAction<any[]>) {
      state.companyMembers = action.payload;
    },
    setCompanyMemberLoading(state, action: PayloadAction<boolean>) {
      state.companyMemberLoading = action.payload;
    },
  },
});

export const { setCompanyMemberLoading, setCompanyMembers } =
  companyMemberSlice.actions;
export default companyMemberSlice.reducer;
